import { Button, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ErrorOutlineRounded as ErrorOutlineIcon } from '@material-ui/icons';
import { Link } from 'react-router-dom';

type Props = {
  title: string;
  backLabel: string;
  backTo: string;
};

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1rem',
    padding: '3rem 1rem',
    textAlign: 'center',
    borderRadius: 4,
  },
  icon: {
    fontSize: '3rem',
    color: '#9e9e9e',
  },
});

export function NotFoundState({ title, backLabel, backTo }: Props) {
  const classes = useStyles();

  return (
    <Paper component="section" elevation={0} className={classes.root}>
      <ErrorOutlineIcon className={classes.icon} />
      <Typography variant="h6" component="h2">
        {title}
      </Typography>
      <Button variant="outlined" size="small" component={Link} to={backTo}>
        {backLabel}
      </Button>
    </Paper>
  );
}
